import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Common } from '../../utils/constants';
import { checkDriverIsVerified } from '../../services/login/loginApi-service';
import { toast } from 'react-toastify';
import { forgotPassword } from '../../services/login/login-service';

const CompromisedPasswordPopup = ({ onChangeStage, closeModal, email }) => {
  const { t } = useTranslation();

  const checkDriver = async (email: string) => {
    let isVerified = true;

    try {
      const response = await checkDriverIsVerified({ email });
      isVerified = response.Data.is_verified;
    } catch (error) {
      toast.error(error.message);
    }

    return isVerified;
  };

  const handleSubmit = async () => {
    const isVerified = await checkDriver(email.toLowerCase());
    if (!isVerified) {
      onChangeStage(Common.AuthStage.SIGNUP_OTP, false);
      return;
    }
    try {
      await forgotPassword({ email });
      onChangeStage(Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE);
    } catch {
      toast.error(t('forgot.toast.error'));
    }
    closeModal();
  };

  return (
    <Modal show={true} className="font-poppins contact-preference-modal" centered>
      <Modal.Body className="modalBody p-0">
        <div className="marketing-consent-title mb-3"> {'InstaVolt'}</div>
        <div className="compromised-password-modal-title mb-2">{t('signup.toast.invalidPassword')}</div>
      </Modal.Body>
      <Modal.Footer className="p-0 mb-4">
        <Button
          className="btn btn-primary w-100 mx-5 compromised-password-accept-button"
          onClick={handleSubmit}
          title={t<string>('authentication.button.continue')}
        >
          {t('authentication.button.continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompromisedPasswordPopup;
